import React, { useContext } from 'react';
import PrimaryDesktopActionBar from './PrimaryDesktopActionBar';
import SecondaryDesktopActionBar from './SecondaryDesktopActionBar';
import { ActionBarContext } from '../../ActionBarContext';
export const DesktopActionBar = ({ isOwner , deviation  })=>{
    const actionBarType = useContext(ActionBarContext);
    return actionBarType === 'secondary' ? /*#__PURE__*/ React.createElement(SecondaryDesktopActionBar, {
        deviation: deviation,
        isOwner: isOwner
    }) : /*#__PURE__*/ React.createElement(PrimaryDesktopActionBar, {
        deviation: deviation,
        isOwner: isOwner
    });
};
DesktopActionBar.displayName = 'DesktopActionBar';
export default DesktopActionBar;
